
import Vue from "vue";
import DentalTopTooth from "./DentalTopTooth.vue";
import axios from "axios";

import { required, required_if, confirmed, length, email, max } from "vee-validate/dist/rules";
import { extend, ValidationObserver, ValidationProvider} from "vee-validate";
import { DentalLog, KeyValuePairOfIntegerAndString, DentalToothMarkingInfo, 
    DentalToothMarkings, DentalLogStatus, DentalSurfaceLookup, WaitlistTreatment } from '../../../types/Sapphire_dto';

extend("required", {
    ...required,
    message: "This field is required."
});

extend("required_if", {
    ...required_if,
    message: "This field is required!"
});

extend("email", {
  ...email,
  message: "This field must be a valid email."
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match."
});

extend("length", {
  ...length,
  message: "This field must have 2 options."
});

extend("max", {
  ...max,
  message:  "This field cannot be longer than 1000 characters."
})

const DentalTreatmentItem = Vue.extend({
  name: "dental-treatment-item",
  components: {
    DentalTopTooth,
    ValidationProvider
  },
  props: {
    dentalToothList: Array as () => Array<KeyValuePairOfIntegerAndString>,
  },
  computed: {
    currentToothMarkings(): DentalToothMarkings {
      return this.treatment.ToothMarkings;
    }
  },
  data: function () {
    return {
      DentalLogStatus,
      currentItemTitle: "Add Item",
      treatment: new Object() as DentalLog,
      selectedTreatments: [] as WaitlistTreatment[],
      selectedTooth: new Object() as KeyValuePairOfIntegerAndString,
      treatmentStatusList: [
        {
          text: "Pre Existing",
          value: "1",
          buttonVariant: "dental-preexisting",
        },
        { text: "On Waitlist", value: "2", buttonVariant: "danger" },
        { text: "Completed Procedure", value: "3", buttonVariant: "primary" },
        // { text: "Missing Teeth", value: "5", buttonVariant: "secondary" }
      ],
      medicalProblemList: [],
      dentalTreatmentList: [],
      dentalLocList: [],
      dentalCompletedTreatmentList: [],
      form: {
        toothList: null,
      },
      dateCheck: true,
    };
  },
  mounted() {
    //mounted is an event in the lifecyle of a vue component
    this.loadDropdowns();
  },
  watch: {
    "treatment.LogType": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.$emit("resetValidation");
      }
    },
    selectedTreatments: function (newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.selectedTreatments && this.selectedTreatments[0] && this.treatment.ID == 0 ) {
          this.treatment.Loc = this.selectedTreatments[0].DefaultLoc;
        }
      }
    },
    selectedTooth: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.treatment.selectedTeeth.length = 0;
        this.treatment.selectedTeeth.push(this.selectedTooth);
      }
    },
    "treatment.waitlistTreatment": function (newVal, oldVal) {
      if (newVal != oldVal && this.treatment.ID > 0) {

        this.selectedTreatments = [];
        this.selectedTreatments.push(this.treatment.waitlistTreatment);
        this.treatment.Loc = this.treatment.waitlistTreatment.DefaultLoc;
        if (!this.treatment.waitlistTreatment.TopOfToothFlag) {
          //If this treatment we are editing had tooth markings and the new one doesn't, then we need to wipe them when they change the treatment.
          let currentToothMarkings: DentalToothMarkings = {
            ToothID: 0,
            ID: 0,
            RightInfo: this.addNewInfo(),
            LeftInfo: this.addNewInfo(),
            TopInfo: this.addNewInfo(),
            BottomInfo: this.addNewInfo(),
            CenterInfo: this.addNewInfo(),
            Session_Date: undefined,
            WaitlistID: 0,
            DentalTreatmentID: 0,
            patientID: 0,
            InactiveFlag: false
          };

          this.treatment.ToothMarkings= currentToothMarkings;
        }
      }
    },
    "treatment.ItemStatus": function (newVal, oldVal) {
      if (newVal != oldVal && this.treatment.ID == 0) {
          this.dateCheck = true;
          this.treatment.LogItemDate = new Date(Date.now());
      }
    },
    "treatment.FormattedCreateDate": function (newVal) {
      if (newVal == "01/01/1900 12:00 PM") {
          this.treatment.LogItemDate = new Date('1900-01-01T12:00:00Z');
          this.dateCheck = false;
      }
    },
  },
  methods: {
    handleMarkingChange(tm: DentalToothMarkingInfo, location: string) {
      if (!this.treatment.ToothMarkings)
      {
        this.treatment.ToothMarkings = {
          ToothID: 0,
          ID: 0,
          Session_Date: undefined,
          WaitlistID: 0,
          DentalTreatmentID: 0,
          patientID: 0,
          InactiveFlag: false
        };
      }

      switch (location) {
        case "right":
          this.treatment.ToothMarkings.RightInfo = tm;
          break;
        case "left":
          this.treatment.ToothMarkings.LeftInfo = tm;
          break;
        case "top":
          this.treatment.ToothMarkings.TopInfo = tm;
          break;
        case "bottom":
          this.treatment.ToothMarkings.BottomInfo = tm;
          break;
        case "center":
          this.treatment.ToothMarkings.CenterInfo = tm;
          break;
      }
    },
    addNewInfo(): DentalToothMarkingInfo {
      let info: DentalToothMarkingInfo = {
        TreatmentName: this.treatment.waitlistTreatment ? this.treatment.waitlistTreatment.NAME : '',
        SurfaceLookup: DentalSurfaceLookup.Mesial,
        StatusID: 0,
        AssocDate: new Date()
      }
      return info;
    },
    async show(treatmentItem: DentalLog, title: string) {
      //  NEED TO GET A *COPY/CLONE* of treatmentItem, *DO NOT* JUST MAKE IT EQUALS.
      //  THAT JUST assigns the reference pointer of the treatmentItem object to this.treatment.
      
      this.treatment = JSON.parse(JSON.stringify(treatmentItem));
      if(this.treatment.FormattedCreateDate == "01/01/1900 12:00 PM") {
        this.dateCheck = false;
        this.treatment.LogItemDate = new Date('1900-01-01T12:00:00Z');
      }
      else {
        this.dateCheck = true;
      }

      if (treatmentItem.toothID > 0) {
        this.treatment.selectedTeeth = [];
        this.selectedTooth = this.dentalToothList.find(t => t.Key == treatmentItem.toothID);
        this.treatment.selectedTeeth.push(this.selectedTooth);
      }

      this.selectedTreatments = [];
      //TFS 19822:  Reset the selectedTreatments array.
      if (treatmentItem.waitlistTreatment && treatmentItem.waitlistTreatment.ID > 0) {
        this.selectedTreatments.push(treatmentItem.waitlistTreatment);
      }

      this.currentItemTitle = title;
      this.$bvModal.show("AddTreatmentItem");
    },
    hide() {
      this.$bvModal.hide("AddTreatmentItem");
    },
    async loadDropdowns() {
      await this.getDentalTreatmentList();
      // this.getMedicalProblemList();
      await this.getDentalLOCList();
    },
    limitTeeth(count: number) {
      return "and " + count + " more";
    },
    async saveTreatmentItem() {
      //TFS 19822:  handle saving multiple selected treatments here...
      this.selectedTreatments.forEach((wt) => {
        this.treatment.waitlistTreatment = wt;
        this.$emit("saveTreatmentItem", this.treatment);
      })
    },
    async getDentalTreatmentList() {
      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetDentalTreatmentList"
        )
        .then((response) => {
          this.dentalTreatmentList = [];
          this.dentalTreatmentList = JSON.parse(response.data.d);
        })
        .catch(function () {
          // handle error
          // eslint-disable-next-line no-undef
          // tb_remove2();
        });
    },
    async getMedicalProblemList() {
      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetPatientDiagnosisList",
          {
            patientID: this.treatment.patientID,
          }
        )
        .then((response) => {
          this.medicalProblemList = JSON.parse(response.data.d);
        })
        .catch(function () {
          // handle error
          // eslint-disable-next-line no-undef
          // tb_remove2();
        });
    },
    async getDentalLOCList() {
      await axios
        .post("../../../Common/Services/EhrTaskService.svc/GetDentalLOCList")
        .then((response) => {
          this.dentalLocList = [];
          this.dentalLocList = JSON.parse(response.data.d);
        })
        .catch(function () {
          // handle error
          // eslint-disable-next-line no-undef
          // tb_remove2();
        });
    },
    onWaitlistSelected(items: [DentalLog]) {
      if (items.length > 0) {
        //There should be only one item in the selected items array.
        this.treatment.waitlistID = items[0].ID;
      } else {
        this.treatment.waitlistID = 0;
      }
    },
    resetValidation() {
        (this.$refs.AddItemValidation as InstanceType<typeof ValidationObserver>).reset();
    },
    dateCheckboxChecked() {
      if(this.dateCheck == true){
        this.dateCheck=false;
        this.treatment.LogItemDate = new Date('1900-01-01T12:00:00Z');
    }
        else{
        this.dateCheck = true;
        this.treatment.LogItemDate = new Date(Date.now());
    }
    }
  },
});

export type DentalTreatmentItemRef = InstanceType<typeof DentalTreatmentItem>;
export default DentalTreatmentItem;
